/**
 * @module-tag agents-ai-nitro
 * Snapshot of currently mounted panel widgets for frontend client tools.
 * PanelManager writes; chat send reads.
 */ import { clientActionsForResourceUri } from './asana-panel-client-actions';
import { panelTabs, widgetsForTab } from './panel-model';
let latestConversationId = null;
let latestState = null;
/** Optional resourceUri by widgetId (from catalog / frame). */ const resourceUriByWidget = new Map();
export const setMountedPanelSnapshot = (conversationId, state)=>{
    latestConversationId = conversationId;
    latestState = state;
};
export const setPanelWidgetResourceUri = (widgetId, resourceUri)=>{
    if (!resourceUri) {
        resourceUriByWidget.delete(widgetId);
        return;
    }
    resourceUriByWidget.set(widgetId, resourceUri);
};
export const clearMountedPanelSnapshot = (conversationId)=>{
    if (conversationId && conversationId !== latestConversationId) return;
    latestConversationId = null;
    latestState = null;
    resourceUriByWidget.clear();
};
const toRef = (widget)=>{
    var _resourceUriByWidget_get;
    const resourceUri = (_resourceUriByWidget_get = resourceUriByWidget.get(widget.widgetId)) !== null && _resourceUriByWidget_get !== void 0 ? _resourceUriByWidget_get : widget.componentId.startsWith('asana_render_') ? 'ui://widget/asana-panel.html' : undefined;
    const clientActions = clientActionsForResourceUri(resourceUri);
    return {
        tabId: widget.tabId,
        widgetId: widget.widgetId,
        appId: widget.appId,
        appVersionId: String(widget.appVersionId),
        installationId: widget.installationId,
        componentId: widget.componentId,
        resourceUri,
        ...clientActions.length > 0 ? {
            clientActions
        } : {}
    };
};
/** READY widgets on PANEL tabs for the active conversation. */ export const getMountedPanelsForChat = (conversationId)=>{
    if (!conversationId || conversationId !== latestConversationId || !latestState) {
        return [];
    }
    const refs = [];
    for (const tab of panelTabs(latestState)){
        for (const widget of widgetsForTab(latestState, tab.tabId)){
            if (widget.status !== 'READY') continue;
            refs.push(toRef(widget));
        }
    }
    return refs;
};
